/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import cx from 'classnames';
import { Divider, View } from '@az/starc-ui';
import type { ReviewType } from '../../interface/types';
import { Review } from '../Review/Review';
import { Fragment } from 'react';
import { LoadingReview } from '../Review/LoadingReview/LoadingReview';
import styles from './styles.module.scss';
import { FlexGrid } from '@/components/FlexGrid/FlexGrid';
import { useForteDecisionFlagWithTrueDefault } from '@/features/forte/api/getForteDecision';

type ReviewsListProps = {
  reviews: ReviewType[];
  isLoading: boolean;
  selectedKeyword?: string;
};

export const ReviewsList = ({ reviews, isLoading, selectedKeyword }: ReviewsListProps) => {
  const pdpRedesignEnabled = useForteDecisionFlagWithTrueDefault('pdpRedesignEnabled');

  return (
    <FlexGrid className={cx(styles.list, { [styles['--fullWidth']]: pdpRedesignEnabled })}>
      <View as="ul">
        {isLoading ? (
          <>
            <LoadingReview />
            <Divider />
            <LoadingReview />
            <Divider />
            <LoadingReview />
          </>
        ) : (
          reviews.map((review, index) => {
            const isLastReview = index === reviews.length - 1;

            return (
              <Fragment key={review.reviewId}>
                <View as="li">
                  <Review review={review} selectedKeyword={selectedKeyword} />
                </View>
                {!isLastReview ? <Divider /> : null}
              </Fragment>
            );
          })
        )}
      </View>
    </FlexGrid>
  );
};
